//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const NestedFoldersCreationInSites: FeatureFlag = {"Id":"NestedFoldersCreationInSites","Label":"Can create nested folders in sites","Impact":"Users are allowed to create folders within folders","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":3};
